import { MutableRefObject, useEffect } from 'react';

export function useOutsideAlerter({
  ref,
  secondRef,
  action,
}: {
  ref: MutableRefObject<HTMLElement | null>;
  secondRef?: MutableRefObject<HTMLElement | null>;
  action: () => void;
}) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (
        ref.current &&
        !ref.current.contains(event.target as HTMLElement) &&
        (secondRef?.current === null ||
          (secondRef?.current && !secondRef.current.contains(event.target as HTMLElement)))
      ) {
        action();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, action, secondRef]);
}
